import { useState } from "react";

import clsx from "clsx";

import { InfoCircleIconComponent, LockIconComponent } from "assets/icons";
import useTranslation from "hooks/useTranslation";
import { PACKAGE_UPGRADE_LINK } from "utils/constants";

function LockedFeature({ text = "قفل", showOnlyInfoBadge, classNames }) {
  const [showHint, setShowHint] = useState(false);
  const { getTranslation } = useTranslation(["COMMON"]);
  const { t } = getTranslation();

  const notifStyleClass = classNames?.notif;

  return (
    <div
      className="locked-feature-container"
      onMouseEnter={() => {
        setShowHint(true);
      }}
      onMouseLeave={() => {
        setShowHint(false);
      }}
    >
      <div
        className={clsx(["locked-feature-hint", notifStyleClass])}
        data-show={showHint}
      >
        {t("TO_USE_YOU_SHOULD_UPGRADE")}{" "}
        <a rel="noreferrer" target="_blank" href={PACKAGE_UPGRADE_LINK}>
          {t("UPGRADE_LINK")}
        </a>
      </div>
      <div className="flex flex-ai-c flex-columngap-4">
        <InfoCircleIconComponent className="info-circle-icon" />
        {!showOnlyInfoBadge && <span>{text}</span>}
      </div>
      {!showOnlyInfoBadge && <LockIconComponent className="lock-icon" />}
    </div>
  );
}

export default LockedFeature;
